<lib-navbar [centerJustified]="false" [links]="links"></lib-navbar>
<lib-header-hero
  [orderInfoTop]="orderInfoTop"
  [location]="location"
  [menuItem]="menuItem"
  [basket]="basket"
></lib-header-hero>
<lib-olo-menu [categories]="categories" [text]="text"></lib-olo-menu>
